import { createApp } from 'vue';
import DngToAvifConverter from '../Components/DngToAvifConverter.vue';

const root = document.getElementById('dng-to-avif-converter');
if (root) {
  createApp(DngToAvifConverter).mount('#dng-to-avif-converter');
}
